import * as React from 'react';

import { ProFeatureTooltipContent } from 'blocks/Pricing';
import Tooltip from 'components/Tooltip';

import { RefType } from 'types';
import AccessControl, { AccessControlProps } from '../AccessControl';
import OptionTile, { OptionTileProps } from './OptionTile';

export type AccessControlOptionTileProps<P = any> = AccessControlProps &
  OptionTileProps<P> & {
    onUpgrade?: () => void;
    proTooltipId?: string;
  };

const AccessControlOptionTile = React.forwardRef(
  <P extends {} = any>(
    {
      active,
      className,
      disabled,
      featurePath,
      icon,
      id,
      integratorBrand,
      label,
      onClick,
      onUpgrade,
      params,
      proTooltipId,
      showProLabel,
      type,
    }: AccessControlOptionTileProps<P>,
    ref: RefType<typeof OptionTile>,
  ) => (
    <AccessControl featurePath={featurePath}>
      {({ state, reason }) => {
        const isProGated = state === 'pro-gated';

        const tile = (
          <OptionTile
            {...{
              active,
              className,
              disabled,
              icon,
              id,
              integratorBrand,
              label,
              params,
              ref,
            }}
            onClick={isProGated && onUpgrade ? onUpgrade : onClick}
            showProLabel={isProGated ? true : showProLabel}
            tooltip={reason}
            type={(() => {
              if (state === 'locked' || state === 'coming-soon') {
                return state;
              }
              return type;
            })()}
          />
        );

        if (!isProGated) {
          return tile;
        }

        return (
          <Tooltip
            animation
            preventHideOnHover
            id={proTooltipId ?? `${id}-pro-tooltip`}
            placement="top"
            content={ProFeatureTooltipContent}
          >
            {tile}
          </Tooltip>
        );
      }}
    </AccessControl>
  ),
);

export default AccessControlOptionTile;
